<template>
  <div
    v-if="location"
    class="location-block"
    :class="{
      'location-block--secondary': secondary,
      'location-block--selected': selected,
    }"
    v-on:click="handleLocationClick"
  >
    <div class="location-block__content">
      <div class="location-block__name">{{ location.name }}</div>
      <div class="location-block__code">{{ location.code }}</div>
    </div>
    <div class="location-block__status-list">
      <div
        class="location-block__status location-block__status--red"
        :class="{ 'location-block__status--disabled': !location.hasIncidents }"
      >
        {{ getDictionaryEntry("modalLocation.locationBlock.labelIssue") }}
      </div>
      <div
        class="location-block__status location-block__status--yellow"
        :class="{ 'location-block__status--disabled': !location.hasOverdue }"
      >
        {{
          getDictionaryEntry("modalLocation.locationBlock.labelTasksOverdue")
        }}
      </div>
    </div>
    <div v-if="secondary" class="location-block__icon">
      <IconChevron />
    </div>
  </div>
</template>

<script>
import IconChevron from "./icons/IconChevron.vue";

export default {
  name: "LocationBlock",
  components: {
    IconChevron,
  },
  props: {
    location: {
      type: Object,
      default: () => {},
    },
    secondary: {
      type: Boolean,
      default: false,
    },
    selected: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    handleLocationClick() {
      this.$emit("location-click", this.location);
      localStorage.setItem("location", this.location.code);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/breakpoints.scss";

.location-block {
  position: relative;
  height: var(--accordion--height);
  display: flex;
  align-items: center;
  padding: 0 1.8rem;
  display: flex;
  justify-content: space-between;
  background-color: var(--color-grey--light);
  border-radius: var(--border-radius);
  color: var(--color-primary);

  @include tablet-portrait {
    flex-direction: row;
    align-items: unset;
    padding: 0 calc(2.1rem + var(--accordion-item-trigger--width)) 0 1.8rem;
  }

  &:hover {
    cursor: pointer;
    background-color: var(--color-grey--extralight);
  }

  &--secondary {
    border: 0.1rem solid var(--color-grey--dark);
    background-color: var(--color-white);
    margin: 0 1.7rem;
  }

  &--selected {
    border: 0.2rem solid var(--color-green);
    background-color: var(--color-grey--extralight);
  }
}

.location-block__content {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.location-block__name {
  font-size: 1.4rem;
  font-weight: var(--font-weight--semibold);
  margin-bottom: 0.2rem;

  @include tablet-portrait {
    font-size: 1.6rem;
  }
}

.location-block__code {
  font-size: 1.1rem;

  @include tablet-portrait {
    font-size: 1.2rem;
  }
}

.location-block__status-list {
  display: flex;
  flex-direction: column;
  align-items: flex-end;

  @include tablet-portrait {
    flex-direction: row;
    align-items: unset;
  }
}

.location-block__status {
  display: flex;
  align-items: center;
  font-size: 1.1rem;
  text-align: right;
  margin: 0.5rem 0;

  @include tablet-portrait {
    margin: 0;
    margin-right: 2.7rem;
    font-size: 1.6rem;

    &:last-child {
      margin-right: 0;
    }
  }

  &:after {
    content: "";
    display: inline-block;
    width: 1.2rem;
    height: 1.2rem;
    margin-left: 1.1rem;
    border-radius: 50%;

    @include tablet-portrait {
      width: 1.5rem;
      height: 1.5rem;
    }
  }

  &--red::after {
    background-color: var(--color-red);
  }

  &--yellow::after {
    background-color: var(--color-yellow);
  }

  &--disabled {
    opacity: 0.1;
  }
}

.location-block__icon {
  position: absolute;
  top: 2rem;
  right: 3rem;
  width: 1.3rem;
  transform: rotate(-90deg);
}
</style>
